import { FunctionComponent, ReactElement } from 'react';
import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { BreadcrumbsProps } from './types';

const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = ({
	maxItems = 8,
	separator = <NavigateNextIcon />,
	ariaLabel = 'breadcrumbs',
	items,
	...rest
}): ReactElement => (
	<MuiBreadcrumbs
		maxItems={maxItems}
		separator={separator}
		aria-label={ariaLabel}
		sx={{
			'& .MuiSvgIcon-root': { fontSize: '1.25rem' },
		}}
		{...rest}
	>
		{items.map((item, key) =>
			item.path ? (
				<Link underline="none" key={key + 1} color="inherit" href={item.path}>
					{item.title}
				</Link>
			) : (
				<Typography key={key + 1} color="text.primary">
					{item.title}
				</Typography>
			)
		)}
	</MuiBreadcrumbs>
);

export default Breadcrumbs;
